import { Spinner } from "@vwfs-bronson/bronson-react";
import React, { createContext, useEffect, useState } from "react";

export type PathnameContextType = {
    pathname: string;
    setPathname: (payload: string) => void;
};

export const PathnameContext = createContext<PathnameContextType | undefined>(undefined);

interface PathnameProviderProps {
    children: React.ReactNode;
}

const PathnameProvider: React.FC<PathnameProviderProps> = ({ children }) => {
    const [pathname, setPathname] = useState<string>('');

    useEffect(() => {
        setPathname(window?.location?.pathname?.split('/')?.[1] || 'retail');
    }, [])

    return (
        <PathnameContext.Provider
            value={{
                pathname,
                setPathname,
            }}
        >
            {pathname ? children : <Spinner fullPage />}
        </PathnameContext.Provider>
    );
};

export default PathnameProvider;
